var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "thankyou" }, [
      _c("div", { staticClass: "container container-small text-center" }, [
        _c("div", { class: _vm.isLoggedIn ? "loggedin" : "not-loggedin" }, [
          _c("i", { staticClass: "far fa-check-circle" }),
          _c("div", { staticClass: "heading black" }, [
            _vm._v(_vm._s(_vm.$t("thank_you_placed_order_title"))),
          ]),
          _vm.paymentMethodMessage
            ? _c("div", { staticClass: "txt" }, [
                _vm.orderHasVignetteProducts
                  ? _c("div", { staticClass: "warning-triangle" }, [
                      _vm.isLoggedIn
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("thank_you_see_info_order"))),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("thank_you_see_info_order_not_loggedin")
                              )
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _c("p", { staticClass: "main-text" }, [
                  _vm._v(" " + _vm._s(_vm.paymentMethodMessage) + " "),
                ]),
                !_vm.isLoggedIn
                  ? _c("div", { staticClass: "extra-txt" }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("thank_you_extra_info_not_loggedin")
                            ) +
                            " "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "action-button" },
            [
              _vm.isLoggedIn
                ? _c("router-link", { attrs: { to: { name: "my-orders" } } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.$t("thank_you_my_orders")))]
                    ),
                  ])
                : _c(
                    "router-link",
                    { attrs: { to: { name: "new-account" } } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("btn_create_account")) + " "
                          ),
                        ]
                      ),
                    ]
                  ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }